import { ref } from 'vue'

import { useNavigation } from '@/composables/useNavigation'

export function useLoginGatedResource() {
  const { navigateTo } = useNavigation()

  const loginGatedResourceData = ref<{ loggedInUrl: string; guestUrl: string } | null>(null)
  const isLoginGatedResourceModalVisible = ref(false)

  function onLoginGatedResourceRequested(resourceData: { loggedInUrl: string; guestUrl: string }) {
    loginGatedResourceData.value = resourceData
    isLoginGatedResourceModalVisible.value = true
  }
  function openLoginGatedResource(userLoginState: 'loggedIn' | 'guest') {
    if (!loginGatedResourceData.value) return

    const { loggedInUrl, guestUrl } = loginGatedResourceData.value
    const urlByLoginState = {
      loggedIn: loggedInUrl || guestUrl,
      guest: guestUrl,
    }
    const urlToOpen = urlByLoginState[userLoginState]
    navigateTo(urlToOpen, '_blank')

    loginGatedResourceData.value = null
    isLoginGatedResourceModalVisible.value = false
  }

  return {
    loginGatedResourceData,
    isLoginGatedResourceModalVisible,
    onLoginGatedResourceRequested,
    openLoginGatedResource,
  }
}
